/**
 * The FunnelKeeper mark: three stacked bars that narrow — a funnel. Accent
 * steps 1–3 from the brand kit. It appears on cards the Keeper proposed, so a
 * human can always tell an AI proposal from a system-generated one at a glance.
 */
export function KeeperMark({ size = 20 }: { size?: number }) {
  const w = (size * 76) / 56;
  return (
    <svg width={w} height={size} viewBox="0 0 76 56" aria-hidden="true" focusable="false">
      <rect x="0" y="0" width="76" height="14" rx="2" fill="var(--keeper)" />
      <rect x="12" y="21" width="52" height="14" rx="2" fill="var(--keeper-2)" />
      <rect x="24" y="42" width="28" height="14" rx="2" fill="var(--keeper-3)" />
    </svg>
  );
}

export function BrandLockup({ markSize = 20 }: { markSize?: number }) {
  return (
    <span className="brand-lockup">
      <KeeperMark size={markSize} />
      <span className="brand-name">
        <span className="brand-funnel">Funnel</span>
        <span className="brand-keeper">Keeper</span>
      </span>
    </span>
  );
}

export function KeeperBadge() {
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <KeeperMark size={13} />
      <span
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: 10,
          letterSpacing: "0.09em",
          textTransform: "uppercase",
          color: "var(--keeper)",
        }}
      >
        Keeper
      </span>
    </span>
  );
}
